import { Card } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import PropTypes from "prop-types";
import MapView from "./MapView";

function CameraLocationCard({ location, devices }) {



    return (<Card>
        <SoftBox p={2}>
            <SoftTypography>{location.name}</SoftTypography>
            <SoftBox sx={{height: "200px"}}>
                <MapView {...{position: location.position, geoJSON: location.geojson}}/>
            </SoftBox>
        </SoftBox>
    </Card>)
}

CameraLocationCard.propTypes = {
    event: PropTypes.object,
    devices: PropTypes.array
}


export default CameraLocationCard;